export default "assets/images/background-6bd411ef.jpg";